import React from "react";
import { Modal, Typography, Button } from "antd";
import { ExclamationCircleOutlined, InfoCircleOutlined, WarningOutlined, CloseCircleOutlined } from "@ant-design/icons";

const { Title, Paragraph } = Typography;

type ErrorType = "error" | "warning" | "info" | "restriction";

interface ErrorModalProps {
  visible: boolean;
  title?: string;
  message: string;
  onClose: () => void;
  type?: ErrorType;
  width?: number;
  closable?: boolean;
  maskClosable?: boolean;
}

const getIconAndColor = (type: ErrorType) => {
  switch (type) {
    case "warning":
      return { icon: WarningOutlined, color: "#faad14" };
    case "info":
      return { icon: InfoCircleOutlined, color: "#1677ff" };
    case "restriction":
      return { icon: CloseCircleOutlined, color: "#ff7a45" };
    case "error":
    default:
      return { icon: ExclamationCircleOutlined, color: "#ff4d4f" };
  }
};

const getDefaultTitle = (type: ErrorType) => {
  switch (type) {
    case "warning":
      return "Warning";
    case "info":
      return "Information";
    case "restriction":
      return "Access Restricted";
    case "error":
    default:
      return "Error";
  }
};

const ErrorModal: React.FC<ErrorModalProps> = ({
  visible,
  title,
  message,
  onClose,
  type = "error",
  width = 500,
  closable = true,
  maskClosable = true,
}) => {
  const { icon: IconComponent, color } = getIconAndColor(type);
  const modalTitle = title || getDefaultTitle(type);

  return (
    <Modal
      open={visible}
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <IconComponent style={{ color, fontSize: 20 }} />
          <Title level={4} style={{ margin: 0, color }}>
            {modalTitle}
          </Title>
        </div>
      }
      onCancel={onClose}
      closable={closable}
      maskClosable={maskClosable}
      footer={[
        <Button key="close" type="primary" onClick={onClose}>
          Close
        </Button>,
      ]}
      centered
      destroyOnClose
      width={width}
    >
      <div style={{ padding: "16px 0" }}>
        <Paragraph style={{ fontSize: 16, margin: 0, lineHeight: 1.6 }}>
          {message}
        </Paragraph>
      </div>
    </Modal>
  );
};

export default ErrorModal;
